import type { StringGUID } from "@pdfking/tfunc"
import { GuidToString, UUID } from "@pdfking/tfunc"

export default (): StringGUID => GuidToString(UUID())
